import { render } from "./events.vue?vue&type=template&id=3c1381ad&ts=true"
import script from "./events.vue?vue&type=script&lang=ts"
export * from "./events.vue?vue&type=script&lang=ts"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__